import { planTargetNum } from './carePlanTargets';

// The chart target lines read the CARE PLAN, not a care_goal row (retired 2026-08-26).
// `planTargetNum` returns null for a non-comparable operator, so a percentage target
// (`reduce_by_pct`) draws no line at all — correct: there is no single pound value to draw.

const SYSTOLIC = 'bp_systolic';
const WEIGHT = 'weight';

export const CareGoals = {
  /** Authored systolic ceiling (mmHg), or null. */
  systolicTarget: (planTargets?: unknown): number | null => planTargetNum(planTargets, SYSTOLIC),
  /** Authored absolute weight target (kg), or null — null for a %-reduction goal. */
  weightTargetKg: (planTargets?: unknown): number | null => planTargetNum(planTargets, WEIGHT),
};
